var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor"},[_c('div',{staticClass:"front"},[_vm._t("front")],2),_c('div',{staticClass:"back"},[_vm._t("back")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }